// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tabbedContainerStyles } from "@tps/App/Widgets/TabbedContainer/TabbedContainer";
import { css } from "styled-components";

tabbedContainerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

tabbedContainerStyles.title = {
    variant: "h2",
    color: "common.ui6",
    css: css`
        display: flex;
        margin-bottom: 20px;
    `,
};